'use client'
import { useEffect } from 'react'

import Link from 'next/link'
import useScrollSpy from './scrolling'

interface IProps {
  arrayOfLinks?: ({ label: string; href: string } | null | undefined)[]
  title?: string
}
export const AnchorLink = ({ arrayOfLinks, title }: IProps) => {
  useEffect(() => {
    const currentHash = window.location.hash.substring(1)
    if (currentHash) {
      const targetElement = document.getElementById(currentHash)
      if (targetElement) {
        const yOffset = -70
        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }
    }
  }, [])

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, href: string) => {
    e.preventDefault()
    const targetId = href.substring(1)
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      const yOffset = -70
      const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
      window.history.pushState(null, '', href)
    }
  }

  const filteredArrayOfLinks = arrayOfLinks?.filter((item) => item !== null)
  const sectionIds = filteredArrayOfLinks?.map((item) => item?.href ?? '') ?? ['']
  useScrollSpy(sectionIds)
  return (
    <div>
      <span className="hidden md:block font-bold text-xl">{title}</span>
      <ul className="hidden md:block flex-col h-full">
        {filteredArrayOfLinks?.map(
          (item, index) =>
            item != null && (
              <li key={item.href}>
                <Link
                  title={item.label}
                  href={item.href}
                  className="flex flex-wrap mt-[1px] py-[5px] px-[11px] text-sm hover:text-blue-700"
                  onClick={(e) => handleClick(e, item.href)}
                >
                  <span>
                    {index + 1}. {item.label}
                  </span> 
                </Link>
              </li>
            ),
        )}
      </ul>
      <div className="hidden md:block pt-6 mr-4 divider"></div>
    </div>
  )
}

export default AnchorLink
